import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "columns container mb-4" }
const _hoisted_2 = { class: "column is-full-mobile is-half-desktop" }
const _hoisted_3 = { class: "quiz-image mb-5" }
const _hoisted_4 = { class: "is-full" }
const _hoisted_5 = { class: "has-text-centered mb-4" }
const _hoisted_6 = { class: "cta has-text-centered p-3" }
const _hoisted_7 = { class: "mb-4 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_image = _resolveComponent("dynamic-image")!
  const _component_quiz_failed_details = _resolveComponent("quiz-failed-details")!
  const _component_quiz_info = _resolveComponent("quiz-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "head mb-2" }, [
      _createElementVNode("div", { class: "p-3" }, "Skill Assessment"),
      _createElementVNode("hr", { class: "m-0" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_dynamic_image, { image: _ctx.quizImage }, null, 8, ["image"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "has-text-centered bold-text is-size-5 mb-5" }, "Unfortunatly You Didn't Pass, But You Have One More Try", -1)),
          _createElementVNode("div", _hoisted_5, " You didn't pass the " + _toDisplayString(_ctx.quizName) + " assessment this time. Don't worry - this just means there's room to grow your understanding. Take some time to review the material and try again when you're ready. You've got this! ", 1),
          _createVNode(_component_quiz_failed_details)
        ])
      ]),
      _createVNode(_component_quiz_info)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "is-primary button is-fullwidth py-3 medium-text",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args)))
        }, "Retry Skill Assessment")
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "disclaimer is-size-6" }, " By starting this assessment, you agree to complete it honestly and without external assistance. ")
      ], -1))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
  ], 64))
}